<template>
  <div class="wrapper">
    <preview url="https://img2.tutubox.cn/shineiTwo.jpg" :markers="marker"  @clickMarker="clickArrow"/>
  </div>
</template>

<script>
import preview from '@/components/preview.vue'

// import DeviceOrientationControls from '@/utile/DeviceOrientationControls'
export default {
  name: "houseTwo",
  components: {
    preview
  },
  data() {
    return {
      marker: [{
            id: "arrowRight",
            longitude: 1.5,
            latitude: -0.3,
            image: "new_right.png",
            width: 50,
            height: 50,
            anchor: "bottom center"
        }]
    };
  },
   methods: {
    clickArrow() {
      this.$router.push('/houseOne')
    }
  }
};
</script>

<style lang="less" scope>

</style>